export const privacypolicyURL = "https://www.ra9plus.jp/privacypolicy"
